import { apiRequest } from "./_api";

export async function postEmailTest(
  postEmailTestDto: PostEmailTestDto
): Promise<ResponseEmailTestDto> {
  return await apiRequest<ResponseEmailTestDto>(
    "post",
    `/sendEmails/send-email-test-smtp`,
    postEmailTestDto
  );
}
